<template>
	<div @click="$emit('update:value', !value)" ref="menu" class="imdex-menu">
		<slot name="template"></slot>
		<transition enter-active-class="zoomIn" leave-active-class="fadeOutDown">
			<div v-if="value" ref="dropdown" class="imdex-dropdown-menu animated-fast">
				<slot name="dropdown"></slot>
			</div>
		</transition>
	</div>
</template>
<script>
import { defineComponent } from "vue";
export default defineComponent({
	name: "imdex-menu",
	data() {
		return {
			isOpen: false,
			outsideClickListener: null
		};
	},
	props: {
		value: {
			type: Boolean,
			default: false
		},
		position: {
			type: String,
			default: "left"
		}
	},
	beforeUnmount() {
		const body = document.getElementById("app");
		if (this.value) {
			body.removeChild(this.$refs["dropdown"]);
		}
	},
	watch: {
		value(v) {
			this.$nextTick(() => {
				if (v) {
					// let dd = (this.$refs as any).dropdown;
					this.$nextTick(() => {
						const {
							top,
							left,
							width,
							height: iHeight
						} = this.$refs["menu"].getBoundingClientRect();
						const body = document.getElementById("app");

						this.$refs["dropdown"].style.position = "fixed";
						this.$refs["dropdown"].style.top = top + 30 + "px";
						this.$refs["dropdown"].style.width = width + "px";
						this.$refs["dropdown"].style.zIndex = 100000011;
						this.$refs["dropdown"].style.left = left + "px";
						body.appendChild(this.$refs["dropdown"]);

						const wHeight = window.innerHeight;
						const { height } = this.$refs["dropdown"].getBoundingClientRect();
						if (top > wHeight - height) {
							this.$refs["dropdown"].style.top =
								wHeight - height - iHeight * 3 + "px";
						} else {
							this.$refs["dropdown"].style.top = top + "px";
						}
					});

					window.addEventListener(
						"mousedown",
						(this.outsideClickListener = (e) => {
							const [x, y] = [e.pageX, e.pageY];
							const elements = document.elementsFromPoint(x, y);
							for (let i = 0; i < elements.length; i++) {
								if (elements[i].classList.contains("imdex-dropdown-menu")) {
									return;
								}
							}

							window.removeEventListener("mousedown", this.outsideClickListener);
							this.$emit("update:value", false);
							// this.$refs["dropdown"].remove();
						})
					);
				}
			});
		}
	}
});
</script>
<style lang="scss">
.imdex-menu {
	position: relative;
	top: 0;
	.imdex-dropdown-menu {
		position: fixed;
		background: #fff;
		right: 100%;
		z-index: 10000;
		transform: translateY(50px);
		top: 100%;
		ul {
			li {
				background: #fff;
				padding: 5px 15px;
				white-space: nowrap !important;
				color: $imdex-dark;
				transition: all 0.3s ease;
				cursor: pointer;
				&:hover {
					background: $imdex-grey;
				}
			}
		}
	}
}
</style>
